import { FeatureType } from "../constant";

export class CompanyFeatures {
    feature: FeatureType;
    allow: boolean;
    data: any;
}

export class CompanyFeaturesDetail extends CompanyFeatures {
    companyId: number;
    companyTitleTh: string;
    companyTitleEn: string;
    paymentMethod: string;
    limitBudget: boolean;
    normalBudget: number;
    normalBudgetUnlimited: boolean;
    normalCoBudget: number;
    normalCoBudgetUnlimited: boolean;
    normalBudgetPerMonth: number;
    normalBudgetPerYear: number;
    taxAddress: string;
    taxId: string;
    taxName: string;
    limitRoom: number;
    multiPayment: boolean;
    shareBudget: boolean;
    travelPolicyList: TravelPolicy[];
    allowCorporateFleet: boolean;
    allowCreditTerm: boolean;
    allowMultiPaymentCorporateFleet: boolean;
    allowLimitRoom: boolean;
}

export class TravelPolicy {
    policyId: number;
    policyNameEn: string;
    policyNameTh: string;
    date: string;
    budgetType: string;
    budget: number;
    budgetUnlimited: boolean;
    coBudget: number;
    coBudgetUnlimited: boolean;
    days: string[];
}



// WEBPACK FOOTER //
// ./src/app/model/menu/companyFeatures.ts